// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-location-access-radio-group label{margin-right:.4em}.user-location-access-radio-group label input[type=radio]{margin-left:1em;margin-right:.2em;margin-top:.5em}", ""]);
// Exports
module.exports = exports;
